import { createApi } from '@reduxjs/toolkit/query/react';

import { createBaseQuery } from '../../common/api/createBaseQuery';
import { IAppContext } from '../../common/types/applicationContext';

export type TOfferCalculatorApiEndpoits = keyof typeof offerCalculatorApi.endpoints;
export let offerCalculatorApi: ReturnType<typeof createOfferCalculatorApi>;

export const createOfferCalculatorApi = (ctx: IAppContext) => {
  const newApi = createApi({
    reducerPath: 'offerCalculatorApi',
    baseQuery: createBaseQuery(ctx),
    endpoints: builder => ({
      getSettings: builder.query<unknown, void>({
        query: parameters => ({
          parameters,
          fetchFunction: async () => ({
            response: {
              foo: 'bar',
            },
            statusCode: 200,
            headers: [],
          }),
          loggerInfo: {
            description: 'Получение настроек лендинга',
            degradation: 'Критическая ошибка, недоступны словари банков и регионов',
          },
        }),
      }),
    }),
  });

  offerCalculatorApi = newApi;

  return newApi;
};
